import { useCallback } from "react";
import { App } from "antd";

const useApi = () => {
  const { message } = App.useApp();

  const fetch = useCallback(
    <T>(
      api: () => Promise<T>,
      {
        success = "",
        setLoading = () => {},
        showError = true,
      }: {
        success?: string | ((data: T) => string);
        setLoading?: (state: boolean) => void;
        showError?: boolean;
      } = {}
    ): Promise<T> =>
      new Promise(async (resolve, reject) => {
        setLoading(true);
        try {
          const data = await api();
          if (success) {
            message.success(
              typeof success === "function" ? success(data) : success
            );
          }
          resolve(data);
        } catch (error: any) {
          if (error?.message && showError) {
            message.error(error.message);
          }
          reject(error);
        } finally {
          setLoading(false);
        }
      }),
    []
  );

  return { fetch };
};

export default useApi;
